<h2 mat-dialog-title>勤務先の編集</h2>
<div mat-dialog-content>
  <form [formGroup]="formGroup">
    <mat-form-field>
      <input
        matInput
        placeholder="勤務先名"
        type="text"
        name="name"
        formControlName="name"
        [attr.value]="data.name"
        [attr.data-test]="'name'"
      />
      <mat-hint>バイト／勤務先名を入力してください</mat-hint>
      <mat-error *ngIf="formGroup.get('name').hasError('required')">
        勤務先名は <strong>必須です</strong>
      </mat-error>
    </mat-form-field>
    <mat-form-field>
      <textarea
        rows="5"
        cols="60"
        matInput
        placeholder="詳細"
        formControlName="description"
      >
    {{ data.description }}
    </textarea
      >
      <mat-hint>バイト／勤務先の詳細を記入してください</mat-hint>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions class="actionArea">
  <button mat-raised-button color="accent" (click)="onClickCancelButton()">
    キャンセル
  </button>
  <button
    mat-raised-button
    color="primary"
    [attr.data-test]="'ok-button'"
    (click)="onClickOkButton()"
    cdkFocusInitial
  >
    OK
  </button>
  <ng-container *ngIf="data.name">
    <button mat-raised-button color="warning" (click)="onClickDeleteButton()">
      削除
    </button>
  </ng-container>
</div>
